import type { Product, ProductId } from '../types/treatment';

export const products: Product[] = [
  { id: 'gonal-f', name: 'GONAL-f', molecule: 'follitropin alfa', unit: 'IU', options: [150, 187.5, 225, 300] },
  { id: 'puregon', name: 'Puregon', molecule: 'follitropin beta', unit: 'IU', options: [100, 150, 200, 225, 300] },
  { id: 'bemfola-ovaleap', name: 'Bemfola / Ovaleap', molecule: 'follitropin alfa', unit: 'IU', options: [150, 225, 300] },
  { id: 'rekovelle', name: 'REKOVELLE', molecule: 'follitropin delta', unit: 'μg', options: [] },
  { id: 'other', name: 'Other', molecule: 'other FSH', unit: 'IU', options: [150, 225, 300] },
];

export function productById(id: ProductId): Product {
  return products.find((p) => p.id === id) ?? products[0];
}

/** Selection value for the manual "Other" dose option. */
export const OTHER_DOSE = 'other';

/** Bounds for manually entered IU doses. */
export const MANUAL_IU_MIN = 37.5;
export const MANUAL_IU_MAX = 450;
